module.exports = __webpack_public_path__ + "02_medium_brown.4fff6cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_medium_brown.png
// module id = 0ZIy
// module chunks = 0